import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { setNavigate } from './navigation';
import { useStores } from './useStores';

// Keeps the MobX routing store in sync with react-router v6,
// and exposes navigate() so stores can call routing.push/replace.
function RouterSyncInner() {
  const location = useLocation();
  const navigate = useNavigate();
  const { routing } = useStores();

  React.useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  React.useEffect(() => {
    if (routing && typeof routing.setLocation === 'function') {
      routing.setLocation(location);
    }
  }, [location, routing]);

  return null;
}

export const RouterSync = observer(RouterSyncInner);
